import { ArrowRight } from 'lucide-react'

import Button from '/react4xp/components/prototype/Button'

import type { NotFoundProps } from './types'

export default function NotFound({
	heading = 'Oops, Page not found',
	body = 'The page may have moved or no longer exists.',
	buttonLabel = 'Go to front page',
	frontPageUrl = '/',
}: NotFoundProps) {
	return (
		<section className="bg-brand-50 min-h-screen flex flex-col justify-center py-16">
			<div className="container flex flex-col items-center text-center gap-6">
				<figure className="w-100.5 max-w-full max-sm:px-4">
					<svg
						className="w-full h-auto max-sm:max-w-84"
						preserveAspectRatio="none"
						overflow="visible"
						style={{ display: 'block' }}
						width="401.413"
						height="150.994"
						viewBox="0 0 401.413 150.994"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<g id="404">
							<path
								id="Vector"
								d="M0 124.077V96.6619L59.5881 2.76988H83.9489V39.9858H69.8153L34.9432 95.2415V96.3778H121.236V124.077H0ZM70.2415 148.224V115.696L70.9517 103.693V2.76988H103.835V148.224H70.2415Z"
								fill="#876995"
							/>
							<path
								id="Vector_2"
								d="M200.671 150.994C187.982 150.994 177.044 147.988 167.859 141.974C158.673 135.914 151.594 127.225 146.623 115.909C141.651 104.545 139.189 90.8854 139.236 74.929C139.284 58.9725 141.77 45.4309 146.694 34.304C151.665 23.1297 158.72 14.6307 167.859 8.80682C177.044 2.93561 187.982 0 200.671 0C213.361 0 224.298 2.93561 233.484 8.80682C242.717 14.6307 249.819 23.1297 254.79 34.304C259.762 45.4782 262.224 59.0199 262.177 74.929C262.177 90.9328 259.691 104.616 254.719 115.98C249.748 127.344 242.669 136.032 233.484 142.045C224.345 148.011 213.408 150.994 200.671 150.994ZM200.671 122.23C208.247 122.23 214.379 118.371 219.066 110.653C223.754 102.888 226.074 90.9801 226.026 74.929C226.026 64.4176 224.961 55.7528 222.83 48.9347C220.7 42.0691 217.74 36.9555 213.952 33.5938C210.164 30.232 205.737 28.5511 200.671 28.5511C193.143 28.5511 187.058 32.3627 182.418 39.9858C177.778 47.5616 175.434 59.2093 175.387 74.929C175.34 85.5824 176.358 94.4129 178.441 101.42C180.572 108.428 183.555 113.66 187.39 117.116C191.225 120.526 195.652 122.23 200.671 122.23Z"
								fill="#C49FD5"
							/>
							<path
								id="Vector_3"
								d="M280.177 124.077V96.6619L339.766 2.76988H364.126V39.9858H349.993L315.121 95.2415V96.3778H401.413V124.077H280.177ZM350.419 148.224V115.696L351.129 103.693V2.76988H384.013V148.224H350.419Z"
								fill="#4A3255"
							/>
						</g>
					</svg>
				</figure>

				<h1 className="h2 text-black-950">{heading}</h1>
				<p className="body text-black-950">{body}</p>

				<Button variant="primary" size="lg" href={frontPageUrl}>
					{buttonLabel}
					<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
				</Button>
			</div>
		</section>
	)
}
